import { LinearProgress, styled } from '@mui/material';
import { memo } from 'react';

/** Thin progress bar across the top of the nearest positioned ancestor, for an inline loading state. */
export const LinearLoadingIndicator = memo(
  styled(LinearProgress)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  }),
);
